import React from "react";
import {
    redirectionWrapper,
    IsEmpty
} from "../../util/commonFunctions";

const FollowRecommendationList = (props) => {
    return (
        <div className="global-right-list">
            {!IsEmpty(props.recoObjects) &&
                <>
                    <h5>{props.headingText}</h5>
                    <ul>
                        {props.recoObjects.map((item, index) => {
                            return (
                                <li key={`followReco - ${props.object} - ${index}`}>
                                    <div className="flex">
                                        <div className="left">
                                            <div
                                                className={props.object == "expert" ? "image-block expert-circle" : "image-block"}
                                                onClick={event => {
                                                    redirectionWrapper(
                                                        props.object,
                                                        event,
                                                        item.id,
                                                        item.name,
                                                        props.parentProps,
                                                        props.parentProps.showLoader,
                                                        props.parentProps.hideLoader
                                                    )
                                                }}
                                            >
                                                {!IsEmpty(item.url) &&
                                                    <img src={item.url} style={{ maxWidth: "100%" }} />
                                                }
                                                {IsEmpty(item.url) && props.object == "series" &&
                                                    <img src="/assets/ausbiz_series_logo.png" style={{ maxWidth: "100%" }} />
                                                }
                                                {IsEmpty(item.url) && props.object !== "series" &&
                                                    <img src="/assets/svg/abiz_placeholder.svg" style={{ maxWidth: "100%" }} />
                                                }
                                            </div>
                                            <div
                                                className="info"
                                                onClick={event => {
                                                    redirectionWrapper(
                                                        props.object,
                                                        event,
                                                        item.id,
                                                        item.name,
                                                        props.parentProps,
                                                        props.parentProps.showLoader,
                                                        props.parentProps.hideLoader
                                                    )
                                                }}
                                            >
                                                <strong>{item.name}</strong>
                                                {props.object == "expert" &&
                                                    <span>{item?.company}</span>
                                                }
                                                {props.object == "company" &&
                                                    <span>{item?.industry?.name}</span>
                                                }
                                            </div>
                                        </div>
                                        <div className="right">
                                            <div
                                                className={item.isFollowing ? "following" : "hide"}
                                                onClick={() => props.unFollowObject(item.id, props.object)}
                                            >
                                                <span></span>
                                                <strong>Following</strong>
                                            </div>
                                            <div
                                                className={!item.isFollowing ? "" : "hide"}
                                                onClick={() => props.followObject(item.id, props.object)}
                                            >
                                                <span></span>
                                                <strong>Follow</strong>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            );
                        })
                        }
                    </ul>
                </>
            }
        </div>
    );
};

export default FollowRecommendationList;
